<template>
  <v-container>
    <div class="account__person mt-3">
      <v-layout row wrap align-center>
        <v-flex xs12>
          <v-layout row wrap align-start v-if="!loading">
            <v-flex sm4>
              <h3 class="mb-20">Poradce:</h3>
              <v-layout row wrap>
                <!-- <v-flex sm4>
                  <img src="" alt="Profil poradce">
                </v-flex> -->
                <v-flex sm12>
                  <div v-if="poradce != null">
                    <h3 class="h2 text-primary mb-2">{{poradce.nazev_osoby}}</h3>
                    <!-- <h4 class="mb-2">Jednatel</h4> -->
                    <p class="bold mb-1">Telefon: <a class="link-black" :href="'tel:'+poradce.telefon">{{poradce.telefon}}</a></p>
                    <p class="bold mb-1">Email: <a class="link-black" :href="'mailto:'+poradce.email">{{poradce.email}}</a></p>
                  </div>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex sm4>
              <h3 class="mb-20">Sídlo společnosti:</h3>
              <h3 class="h2 text-primary mb-2"><span class="text-uppercase">Comfort Commodity</span> a.s.</h3>
              <p class="bold mb-1">
                <a class="link-black" href="https://goo.gl/maps/RpKsoS2o429iNJoz9" target="_blank">Plaská 2119/54a, 323 00 Plzeň</a>
              </p>
              <p class="bold mb-1">Telefon: <a class="link-black" href="tel:+420734232022">+420 734 232 022</a></p>
              <p class="bold mb-3">Email: <a class="link-black" href="mailto:info@comfort-commodity.cz">info@comfort-commodity.cz</a></p>
              <p class="bold mb-1">IČ: 06148000</p>
              <p class="bold mb-1">DIČ: CZ06148000</p>
              <p class="text-gray bold mb-0 fs-14">Zapsaná v&nbsp;OR vedeném u&nbsp;Krajského soudu v&nbsp;Plzni oddíl B, vložka 1990</p>
            </v-flex>
            <v-flex sm3 offset-sm1>
              <h3 class="mb-20">Bankovní spojení:</h3>
              <h4 class="text-gray">CZK</h4>
              <p class="bold mb-1">Raiffeisenbank a.s.</p>
              <p class="bold mb-1">Č.ú.: 2224466677/5500</p>
              <p class="bold mb-1">IBAN: CZ1155000000002224466677</p>
              <p class="bold mb-20">SWIFT: RZBCCZPP</p>

              <h4 class="text-gray">EUR</h4>
              <p class="bold mb-1">Fio banka a.s.</p>
              <p class="bold mb-1">Č.ú.: 2301452827/2010</p>
              <p class="bold mb-1">IBAN: CZ0620100000002301452827</p>
              <p class="bold mb-1">BIC: FIOBCZPPXXX</p>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </div>
  </v-container>
</template>
<script>
  import Base from '../Base'
  export default {
    extends: Base,
    data () {
      return {
        loading: true,
        poradce: null
      }
    },
    mounted () {
      this.load();
    },
    methods: {
      load (f) {
        window.API.get("uzivatel/moje-udaje").then(function(body) {
            this.poradce = body.poradce;
            this.loading = false;
            if (typeof f == "function")
              f();
        }.bind(this)).catch(function(err) {
            console.log(err);
        }.bind(this));
      },
    }
  }
</script>
